module.exports = __webpack_public_path__ + "static/media/Metodos-de-pago.6280c658.svg";